import { entrySplitApi as api } from "../entryApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    statisticSitesControllerCreate: build.mutation<
      StatisticSitesControllerCreateApiResponse,
      StatisticSitesControllerCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites`,
        method: "POST",
        body: queryArg.createSiteStatisticDto,
      }),
    }),
    statisticSitesControllerGetByRange: build.query<
      StatisticSitesControllerGetByRangeApiResponse,
      StatisticSitesControllerGetByRangeApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites/byRange`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          groupBy: queryArg.groupBy,
          lang: queryArg.lang,
        },
      }),
    }),
    statisticSitesControllerGetByYearMonth: build.query<
      StatisticSitesControllerGetByYearMonthApiResponse,
      StatisticSitesControllerGetByYearMonthApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites/bySumYearMonth`,
        params: {
          year: queryArg.year,
          noOfMonths: queryArg.noOfMonths,
        },
      }),
    }),
    statisticSitesControllerGetByYear: build.query<
      StatisticSitesControllerGetByYearApiResponse,
      StatisticSitesControllerGetByYearApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites/byYear`,
        params: {
          year: queryArg.year,
          range: queryArg.range,
        },
      }),
    }),
    statisticSitesControllerGetByMonth: build.query<
      StatisticSitesControllerGetByMonthApiResponse,
      StatisticSitesControllerGetByMonthApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites/byMonth`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    statisticSitesControllerGetByDay: build.query<
      StatisticSitesControllerGetByDayApiResponse,
      StatisticSitesControllerGetByDayApiArg
    >({
      query: (queryArg) => ({
        url: `/statistic-sites/byDay`,
        params: {
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as combinedApi };
export type StatisticSitesControllerCreateApiResponse = unknown;
export type StatisticSitesControllerCreateApiArg = {
  createSiteStatisticDto: CreateSiteStatisticDto;
};
export type StatisticSitesControllerGetByRangeApiResponse =
  /** status 200  */ StatisticSiteByRangeDto;
export type StatisticSitesControllerGetByRangeApiArg = {
  startDate: string;
  endDate: string;
  groupBy: StatisticGroupBy;
  lang: LanguageType;
};
export type StatisticSitesControllerGetByYearMonthApiResponse =
  /** status 200  */ StatisticSiteSumByYearMonthDto;
export type StatisticSitesControllerGetByYearMonthApiArg = {
  year: number;
  noOfMonths: number;
};
export type StatisticSitesControllerGetByYearApiResponse =
  /** status 200  */ StatisticSiteByYearDto[];
export type StatisticSitesControllerGetByYearApiArg = {
  year: string;
  range: number;
};
export type StatisticSitesControllerGetByMonthApiResponse =
  /** status 200  */ StatisticSiteByMonthDto[];
export type StatisticSitesControllerGetByMonthApiArg = {
  startDate: string;
  endDate: string;
};
export type StatisticSitesControllerGetByDayApiResponse =
  /** status 200  */ StatisticSiteByDayDto[];
export type StatisticSitesControllerGetByDayApiArg = {
  startDate: string;
  endDate: string;
};
export type CreateSiteStatisticDto = {
  statsDate: string;
  url: string;
};
export type StatisticSiteByYearDto = {
  label: string;
  year: number;
  views: number;
  uniqueViews: number;
  urlViews: object;
};
export type StatisticSiteByMonthDto = {
  label: string;
  year: number;
  month: number;
  views: number;
  uniqueViews: number;
  urlViews: object;
};
export type StatisticSiteByDayDto = {
  label: string;
  year: number;
  month: number;
  day: number;
  views: number;
  uniqueViews: number;
  urlViews: object;
};
export type StatisticSiteByRangeDto = {
  byYear: StatisticSiteByYearDto[];
  byMonth: StatisticSiteByMonthDto[];
  byDay: StatisticSiteByDayDto[];
};
export type StatisticGroupBy = "day" | "month" | "year";
export type LanguageType = "en" | "cn" | "cnt";
export type StatisticSiteSumByYearMonthDto = {
  year: object;
  month: object;
  quarter: object;
};
export const {
  useStatisticSitesControllerCreateMutation,
  useStatisticSitesControllerGetByRangeQuery,
  useLazyStatisticSitesControllerGetByRangeQuery,
  useStatisticSitesControllerGetByYearMonthQuery,
  useLazyStatisticSitesControllerGetByYearMonthQuery,
  useStatisticSitesControllerGetByYearQuery,
  useLazyStatisticSitesControllerGetByYearQuery,
  useStatisticSitesControllerGetByMonthQuery,
  useLazyStatisticSitesControllerGetByMonthQuery,
  useStatisticSitesControllerGetByDayQuery,
  useLazyStatisticSitesControllerGetByDayQuery,
} = injectedRtkApi;
